import Session from '@/handler/session'
import Branding from '@/components/branding/branding'
import { EventBus } from '@/handler/event-bus'
import Theme from '@/config/theme'

export default {
  data () {
    return {
      favicon: '',
      proyectName: '',
      primaryColor: Theme.PRIMARY_COLOR
    }
  },
  created () {
    EventBus.$on('Settings:settings', () => {
      this.setup()
    })
  },
  mounted() {
    this.setup()      
  },  
  methods: {
    setup () {
      if(Session.getSession().settings) {
        const settings = Session.getSession().settings
        this.favicon = Branding.resolve(settings).defaultIcon
        this.proyectName = settings.proyect_name

        this.changeFavicon()
        this.changeTitle()
        this.createCSS()
      }
    },
    changeFavicon() {
      var link = document.getElementById('app-favicon')
      if (!link) {
        link = document.createElement('link')
        link.id = 'app-favicon'
        document.getElementsByTagName('head')[0].appendChild(link)
      }
      link.type = this.favicon && this.favicon.indexOf('.svg') !== -1
        ? 'image/svg+xml'
        : 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.favicon
    },
    changeTitle() {
      document.title = this.proyectName

      var metas = document.getElementsByTagName("meta");

      for(var i=0;i<metas.length;i++){
        if(metas[i].getAttribute("name")=="apple-mobile-web-app-title") {
            metas[i].setAttribute("content",this.proyectName);
        }                    
      }
    },
    createCSS() {      
      var hoja = document.createElement('style')
      hoja.innerHTML = ""
      hoja.innerHTML = hoja.innerHTML  + ".primary-color { color: " + this.primaryColor + "; }"
      hoja.innerHTML = hoja.innerHTML  + ".primary-color:hover {color: " + this.primaryColor + "; filter:brightness(0.8);}"
      hoja.innerHTML = hoja.innerHTML  + ".primary-background { background: " + this.primaryColor + "; border-color: " + this.primaryColor + "; color: white; }"
      hoja.innerHTML = hoja.innerHTML  + ".primary-background:hover { background: " + this.primaryColor + "; border-color: " + this.primaryColor + "; color: white; filter:brightness(0.8); }";
      
      document.body.appendChild(hoja);
    },        
  }
}
